import { render, staticRenderFns } from "./ViewMachineModelResources.vue?vue&type=template&id=53dac5c2&scoped=true&"
import script from "./ViewMachineModelResources.vue?vue&type=script&lang=js&"
export * from "./ViewMachineModelResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dac5c2",
  null
  
)

export default component.exports